import Typography, { type TypographyProps } from "@mui/material/Typography";

/** Secondary, muted text that supports a title (page lead-in, section blurb). */
export function Subtitle(props: TypographyProps) {
  return <Typography variant="subtitle1" color="text.secondary" {...props} />;
}
